export default {
  layoutSelectors: ["#email"],
  inputIdentifier: "#email",
  label: "block billing checkout (email)"
}
